import React from 'react';
import QuestionLabel from './QuestionLabel';
import { getOptionsFromList } from '../../../lib/Questions';
import { FormPart, optionAttributes, part } from '~/lib/FormCssApi';

const DropdownQuestion = ({ label, value, setValue, settings }) => {
    return (
        <label>
            <QuestionLabel label={label} settings={settings} />
            {settings?.options && (
                <div {...part(FormPart.CONTROL)}>
                    <select
                        {...part(FormPart.INPUT)}
                        value={value}
                        onChange={e => setValue(e.target.value)}
                        className="w-full"
                    >
                        <option value=""> </option>
                        {getOptionsFromList(settings.options).map(
                            (opt, idx) => (
                                <option
                                    value={opt}
                                    key={idx}
                                    {...optionAttributes({
                                        value: opt,
                                        isSelected: value === opt,
                                    })}
                                >
                                    {opt}
                                </option>
                            ),
                        )}
                    </select>
                </div>
            )}
        </label>
    );
};

export default DropdownQuestion;
